import { render, staticRenderFns } from "./ImportLoading.vue?vue&type=template&id=e96321ce&scoped=true&"
import script from "./ImportLoading.vue?vue&type=script&lang=ts&"
export * from "./ImportLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96321ce",
  null
  
)

export default component.exports